import { render, staticRenderFns } from "./ThirdPersonContractDetail.vue?vue&type=template&id=5fdf3ae2&scoped=true"
import script from "./ThirdPersonContractDetail.vue?vue&type=script&lang=js"
export * from "./ThirdPersonContractDetail.vue?vue&type=script&lang=js"
import style0 from "./ThirdPersonContractDetail.vue?vue&type=style&index=0&id=5fdf3ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdf3ae2",
  null
  
)

export default component.exports